import { ArrowUturnLeftIcon } from "@heroicons/react/24/outline";
import { centsToLocalizedString } from "../../../../../../lib/Money";
import type { SalesInvoiceResponse } from "../../CreateInvoicePage/salesInvoiceApi.ts";
import { formatDateDDMMYYYY } from "../../../components/salesInvoices/utils/salesInvoicesFormat.ts";

export type LinkedCreditNote = SalesInvoiceResponse["credit_notes"][number];

const NO_AMOUNT_UNTIL_ISSUED = "nog geen bedrag";

function describeAmount(creditNote: LinkedCreditNote): string {
    if (creditNote.total_payable_cents === null) {
        return NO_AMOUNT_UNTIL_ISSUED;
    }
    return `€ ${centsToLocalizedString(Number(creditNote.total_payable_cents))}`;
}

interface Props {
    creditNotes: LinkedCreditNote[];
    onOpen: (creditNoteId: string) => void;
}

export function LinkedCreditNotesCard({ creditNotes, onOpen }: Props) {
    if (creditNotes.length === 0) {
        return null;
    }

    return (
        <div className="p-6 bg-white rounded-xl shadow-sm border border-gray-100">
            <h3 className="text-sm font-semibold text-gray-900 mb-4">Creditfacturen</h3>
            <ul className="flex flex-col gap-2">
                {creditNotes.map((creditNote) => (
                    <li key={creditNote.id}>
                        <button
                            type="button"
                            onClick={() => onOpen(creditNote.id)}
                            className="w-full flex items-start gap-3 rounded-lg border border-gray-100 px-4 py-3 text-left hover:bg-gray-50 outline-none focus-visible:border-[0.5px] focus-visible:border-[color:var(--primary)]"
                        >
                            <ArrowUturnLeftIcon
                                className="mt-0.5 h-4 w-4 shrink-0 text-gray-400"
                                aria-hidden="true"
                            />
                            <span className="flex flex-col gap-0.5 min-w-0">
                                <span className="text-sm font-medium text-gray-900">
                                    {creditNote.invoice_number ?? "Concept creditfactuur"}
                                </span>
                                <span className="text-xs text-gray-500">
                                    {formatDateDDMMYYYY(creditNote.invoice_date)} ·{" "}
                                    {describeAmount(creditNote)}
                                    {!creditNote.is_issued && " · concept"}
                                </span>
                                {creditNote.credit_reason && (
                                    <span className="text-xs text-gray-400 truncate">
                                        {creditNote.credit_reason}
                                    </span>
                                )}
                            </span>
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}
